const roles = [
  { name: "ADMINISTRATOR", roleId: 3 },
  { name: "SUPERVISOR", roleId: 2 },
  { name: "REGULAR_USER", roleId: 1 },
  { name: "NONE", roleId: 0 },
];

export default roles;
